import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { shortSubjectsAPI } from "../services/api";
import { loadShortSubjects } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";

const ShortSubjectsPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.shortSubjects")}
      api={shortSubjectsAPI}
      reloadThunk={loadShortSubjects}
      requiredPermission={PERMISSIONS.MANAGE_SHORT_SUBJECTS}
      onNavigate={onNavigate}
      columns={[
        { field: "short_subject_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
      ]}
    />
  );
};

export default ShortSubjectsPage;
